// @ts-nocheck
(function () {
  const dock = document.querySelector('[data-dock]');
  if (!dock) return;

  function getLocalePrefix() {
    return window.location.pathname.startsWith('/fr/') || window.location.pathname === '/fr' ? '/fr' : '';
  }

  const trigger = dock.querySelector('[data-search-trigger]');
  const panel = dock.querySelector('[data-dock-search-panel]');
  const input = panel?.querySelector('input.dock-search-input');
  const results = panel?.querySelector('.dock-search-results');
  const statusEl = panel?.querySelector('.dock-search-status');
  const closeBtn = panel?.querySelector('.dock-search-close');
  const viewAll = panel?.querySelector('.dock-search-viewall');
  const searchPanel = dock.querySelector('.dock-panel--search');

  const menuPanel = dock.querySelector('[data-dock-panel]');

  function matchNavWidth() {
    const nav = dock.querySelector('.dock__nav');
    if (!nav || !searchPanel || !menuPanel) return;

    let navWidth = '';

    function applyMenuWidth() {
      if (menuPanel.classList.contains('is-bespoke-mode')) {
        menuPanel.style.width = '';
      } else if (menuPanel.classList.contains('is-open')) {
        menuPanel.style.width = navWidth;
      }
    }

    new ResizeObserver(([entry]) => {
      navWidth = entry.contentRect.width + entry.contentRect.x * 2 + 'px';
      searchPanel.style.width = navWidth;
      applyMenuWidth();
    }).observe(nav);

    new MutationObserver(applyMenuWidth).observe(menuPanel, { attributes: true, attributeFilter: ['class'] });
  }
  if (!trigger || !panel || !input || !results || !statusEl || !closeBtn || !viewAll) return;

  matchNavWidth();

  let abortCtrl = null;
  let lastQuery = '';

  function open() {
    // Fecha painel do menu (hover)
    if (menuPanel) {
      menuPanel.classList.remove('is-open');
      menuPanel.setAttribute('aria-hidden', 'true');

      dock.querySelectorAll('[data-dock-item]').forEach(btn => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    setTimeout(() => input?.focus(), 0);
  }

  function close() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
  }

  // CLICK ONLY
  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    panel.classList.contains('is-open') ? close() : open();
  });

  closeBtn.addEventListener('click', () => {
    input.value = '';
    closeBtn.classList.remove('is-visible');
    search('');
    close();
  });

  // ESC fecha
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  // Clique fora fecha
  document.addEventListener('click', (e) => {
    if (!panel.classList.contains('is-open')) return;
    if (!panel.contains(e.target) && !trigger.contains(e.target)) close();
  });

  function debounce(fn, delay) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  }

  function escapeHtml(str) {
    return String(str || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function render(products) {
    results.innerHTML = products.map(p => {
      const img = p.image || '';
      const sub = [p.vendor, p.product_type].filter(Boolean).join(' / ');
      return `
        <a class="dock-result-card" href="${p.url}" role="listitem">
          <div class="dock-result-img">${img ? `<img src="${img}" alt="">` : ''}</div>
          <div class="dock-result-info">
            <div class="dock-result-title">${escapeHtml(p.title)}</div>
            <div class="dock-result-sub">${escapeHtml(sub)}</div>
          </div>
        </a>
      `;
    }).join('');
  }

  async function search(q) {
    const query = q.trim();
    searchPanel.classList.remove('has-results')
    lastQuery = query;

    if (!query) {
      statusEl.textContent = '';
      results.innerHTML = '';
      viewAll.href = `${getLocalePrefix()}/search`;
      return;
    }

    viewAll.href = `${getLocalePrefix()}/search?q=${encodeURIComponent(query)}`;

    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    const url =
      `/search/suggest.json?q=${encodeURIComponent(query)}` +
      `&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;

    const res = await fetch(url, { signal: abortCtrl.signal });
    const data = await res.json();

    const products = data?.resources?.results?.products || [];

    if (query !== lastQuery) return;

    if (!products.length) {
      searchPanel.classList.remove('has-results')
      statusEl.textContent = '0 items found';
      results.innerHTML = '';
      return;
    }

    searchPanel.classList.add('has-results')
    statusEl.textContent = `${products.length} item${products.length !== 1 ? 's' : ''} found`;
    render(products);
  }

  input.addEventListener('input', debounce(() => {
    const val = input.value;
    closeBtn.classList.toggle('is-visible', val.length > 0);
    search(val);
  }, 180));
})();